import React from "react";
import sampleCsv from "../../assests/csv-sample-file.webp";
import csvFile from "../../assests/attendance-vitiyagyanmela.csv";

const UploadFileInstruction = () => {
  const handleDownload = () => {
    const fileURL = csvFile;
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = "attendance-vitiyagyanmela.csv";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  return (
    <div className="instruction">
      <p className="mb-0 text-warning shadow-sm bg-black d-inline-block py-2 px-4 rounded-2">
        Note:- CSV File data should be this format, please download the sample
        file for the reference.
      </p>
      <img
        src={sampleCsv}
        className=" object-fit-scale shadow-lg my-4 rounded-3 p-3"
        style={{ maxWidth: "1000px", width: "100%", display: "block" }}
        alt="Sample CSV File"
      />
      <button className="download-btn" onClick={handleDownload}>
        Download Sample CSV File
      </button>
    </div>
  );
};

export default UploadFileInstruction;
